import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BookLocationPage from "./BookLocationPage";
import ParcelPlacementPage from "./parcelPlacement/BookLocationPage";
import FullScreenDialog from "../../common/FullScreenDialog";
import { useGetLocationListQuery } from "../../../api/locations/locationsApiSlice";
import { setUseCaseLocations } from "../../../redux/slice/booking/bookingSlice";
import { useDispatch } from "react-redux";
import routes from "../../../routes/routes";

interface BookLocationDialogProps {
  open: boolean;
  locationId?: string;
}

const BookLocationDialog = (props: BookLocationDialogProps) => {
  const location = useLocation();
  const { returnPage } = location.state || {};

  const dispatch = useDispatch();

  // Note: It's currently important that BookLocationPage is only mounted when location is available
  // due to body scroll locking

  const { data: locations } = useGetLocationListQuery("parcel");

  useEffect(() => {
    if (locations) {
      dispatch(setUseCaseLocations(locations));
    }
  }, [locations]);

  return (
    <FullScreenDialog open={props.open}>
      {location.pathname === routes.parcelItemPlacementPath ? (
        <ParcelPlacementPage returnPage={returnPage} />
      ) : (
        <BookLocationPage />
      )}
    </FullScreenDialog>
  );
};

export { BookLocationDialog };
